import axios from "axios";

// Constants

// Acessors

const initialState = {};

export const changeStudyStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const updateStudyStatus =
  (statusId, studyEnrollmentID, reason, withdrawnDate) =>
  async (dispatch, getState) => {
    let body = {
      studyEnrollmentID: studyEnrollmentID,
      statusToUpdate: statusId,
      reasonForChange: reason,
      withdrawnDate,
    };

    return axios
      .put(`/api/study/enroll/status`, body)
      .then(() => {
        return Promise.resolve("Study status updated successfully!");
      })
      .catch((e) => {
        return Promise.reject(
          e.response?.data
            ? e.response.data
            : "There was an error while trying to update the study status!"
        );
      });
  };

export const mapDispatchToProps = {
  updateStudyStatus,
};
